export default "__VITE_ASSET__b862f02c__"